<template lang="pug">
  .col-sm-12.col-md-12.col-lg-12.col-xl-12.mt-1
    template(v-for="i in list")
      span.mr-1
        template(v-if="i.is_pending == 1")
          span.badge.badge-danger {{ $moment(i.working_date).format("DD/MM") + "|" + $t("ui.pending") }}
        template(v-else)
          span.badge.badge-success {{ $moment(i.working_date).format("DD/MM") + "|" + $t("ui.completed") }}
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      list: []
    }
  },
  mounted: function() {
    this.submit()
  },
  methods: {
    submit: function() {
      this.$store
        .dispatch("user/getPendingMatches")
        .then(response => {
          this.loading = true
          if (response.success == true) {
            this.loading = false
            if(response.data.length > 0) {
              this.list = response.data
            }
          }
        })
        .catch(response => {});
    }
  }
}

</script>